module.exports = __webpack_public_path__ + "img/md_yun.c64bea50.png";